// NPM
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { selectTopTagEntities } from 'selectors';

import PropTypes from 'prop-types';
import RankedList from './RankedList';
import TagListItem from './TagListItem';

class TagRankedList extends PureComponent {
  render() {
    const { heading, tags, schema } = this.props;
    if (tags.length) {
      return (
        <RankedList id={`TagRankedList-${schema}`} heading={heading}>
          {tags.map((tag, i) => {
            return <TagListItem tag={tag} key={i} />;
          })}
        </RankedList>
      );
    } else {
      return null;
    }
  }
}

TagRankedList.propTypes = {
  schema: PropTypes.string.isRequired,
  tags: PropTypes.array.isRequired,
  heading: PropTypes.string.isRequired,
};

TagRankedList.defaultProps = {
  topTags: [],
};

function mapStateToProps(state, props) {
  return {
    tags: selectTopTagEntities(state, props.schema),
  };
}

export default connect(mapStateToProps)(TagRankedList);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/RankedLists/TagRankedList.js